import { Component, Input } from '@angular/core';
import { makeid } from 'na-lib';

@Component({
    selector: '[app-location-picker]',
    templateUrl: './location-picker.component.html',
    styleUrls: ['./location-picker.component.css'],
    standalone: false
})
export class LocationPickerComponent {
  @Input('app-location-picker') data:any;


  ngOnInit(){
    this.initMap();

  }

   async initMap() {
    // Request needed libraries.
    const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

    const map = new Map(document.getElementById('map') as HTMLElement, {
        center: { lat: 53.4239163, lng: 12.0947209 },
        zoom: 3,
        mapId: this.data.id ?? makeid(5),
        disableDefaultUI: true,
    });

    if(this.data?.coordinate){
      const pinBackground = new PinElement({
        background: '#FBBC04',
      });
  
      const marker = new AdvancedMarkerElement({
          map,
          position: { lat: 37.4239163, lng: -122.0947209 },//this.data.coordinate
          content: pinBackground.element,
          //gmpClickable: true,
      });
  
  
      // A marker with a with a URL pointing to a PNG.
      const beachFlagImg = document.createElement('img');
      // beachFlagImg.src = 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';
      beachFlagImg.src = '../../assets/img/narravero-pin.svg'
  
      const beachFlagMarkerView = new AdvancedMarkerElement({
          map,
          position: { lat: 37.434, lng: -122.082 },
          content: beachFlagImg,
          title: 'A marker using a custom PNG Image',
          //gmpClickable: true,
          // gmpClickable is removed since its not suported in 3.54, this can be enabeld after angular google-maps update
      });

      let contentString = "this is an example"
      let index = 11 +''
      contentString ='<div class="d-flex flex-column">'
      contentString +='<span>...</span>'    
      contentString +=' </div> '   

      const infoWindow = new google.maps.InfoWindow({
        content: contentString,
        ariaLabel: index,
      });

      // Add a click listener for each marker, and set up the info window.
      marker.addListener('click', ({ domEvent, latLng }) => {
        const { target } = domEvent;
        infoWindow.close();
        infoWindow.setContent(marker.title);
        infoWindow.open(marker.map, marker);
      });


      const infoWindowFlag = new google.maps.InfoWindow({
        content: contentString,
        ariaLabel: index,
      });
      beachFlagMarkerView.addListener('click', ({ domEvent, latLng }) => {
        const { target } = domEvent;
        infoWindowFlag.close();
        infoWindowFlag.setContent(beachFlagMarkerView.title);
        infoWindowFlag.open(beachFlagMarkerView.map, beachFlagMarkerView);
      });
    }
    
  }
}
